import React from 'react';
import { Text, StyleSheet, View } from '@react-pdf/renderer';

interface PdfCredentialDetailsProps {
  data: any;
}

export const PdfVerificationSignatureFooter: React.FC<PdfCredentialDetailsProps> = (props) => {
  const styles = StyleSheet.create({
    text: {
      fontSize: '8px'
    }, 
    footerText: {
      fontSize: 6, color: 'gray', paddingBottom: 2
    }
  });

  return (
    <>
      <View style={{paddingLeft: 20, paddingRight: 20}}>
      <Text style={[styles.text, { textAlign: 'center' }]}>
        If you have any questions about this verification form, please contact ECFMG at{' '}
        <Text style={{ color: '#5F9EA0', textDecoration: 'underline' }}>verifications@ecfmg.org</Text>.
      </Text>
      {props.data.entityId && <Text style={[styles.text, { textAlign: 'center', marginTop: 3 }]}>Entity ID: {props.data.entityId}</Text>}
      <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 10 }}>
        <View>
          <Text style={styles.footerText}>ECFMG® Credential Verification Form</Text>
          <Text style={styles.footerText}>Copyright © 2025 by Intealth. All rights reserved.</Text>
        </View>

        <View style={{ alignItems: 'flex-end' }}>
          <Text style={styles.footerText}>Rev. December 2024</Text>
          <Text style={styles.footerText}>Page 1 of 1</Text>
        </View>
      </View>
      </View>
    </>
  );
};

export default PdfVerificationSignatureFooter;
